export const REHAB_CATEGORY_KEY = "Rehabilitation and Medical Social Services";
export const DEFAULT_SERVICE_CATEGORY_KEY = REHAB_CATEGORY_KEY;
export const DEFAULT_SERVICE_TYPE_KEY = "Medical Social Services";

export const SERVICE_CATEGORY_KEYS = [
  "Community Development",
  "Family & Child Welfare Services",
  "Rehabilitation and Medical Social Services",
  "Services for Offenders",
  "Services for the Elderly",
  "Services for Young People",
  "Social Security",
];

export const getDefaultServiceSelection = () => ({
  categoryKeys: [DEFAULT_SERVICE_CATEGORY_KEY],
  serviceTypeKeys: [DEFAULT_SERVICE_TYPE_KEY],
});

export const getServiceTypeDisplayMode = (categoryKeys) =>
  Array.isArray(categoryKeys) &&
  categoryKeys.length === 1 &&
  categoryKeys[0] === REHAB_CATEGORY_KEY
    ? "enabled"
    : "na";

export const shouldShowServiceTypeFilter = (categoryKeys) =>
  getServiceTypeDisplayMode(categoryKeys) === "enabled";

export const getVisibleServiceTypes = (facilities, categoryKeys) => {
  if (
    !Array.isArray(facilities) ||
    !Array.isArray(categoryKeys) ||
    categoryKeys.length === 0
  ) {
    return [];
  }

  return Array.from(
    new Set(
      facilities
        .filter((facility) => categoryKeys.includes(facility.Category))
        .map((facility) => facility["Type of Service"])
        .filter(Boolean)
    )
  ).sort();
};

export const filterFacilitiesBySelection = (
  facilities,
  categoryKeys,
  serviceTypeKeys = []
) => {
  if (!Array.isArray(facilities)) {
    return [];
  }

  const normalizedServiceTypeKeys =
    getServiceTypeDisplayMode(categoryKeys) === "enabled"
      ? serviceTypeKeys
      : [];

  return facilities.filter((facility) => {
    const categoryMatch =
      !Array.isArray(categoryKeys) ||
      categoryKeys.length === 0 ||
      categoryKeys.includes(facility.Category);
    const serviceTypeMatch =
      !Array.isArray(normalizedServiceTypeKeys) ||
      normalizedServiceTypeKeys.length === 0 ||
      normalizedServiceTypeKeys.includes(facility["Type of Service"]);
    return categoryMatch && serviceTypeMatch;
  });
};
